import { websiteBuilderNormalizeValue } from "../schema/normalization/websiteBuilderNormalizeValue";
import { TWebsiteBuilderDevice } from "../website/shared/device";
import { TWebsiteBuilderContainer } from "./container/websiteBuilderContainer";
import { TWebsiteBuilderElement } from "./element/websiteBuilderElement";
import { TWebsiteBuilderSection } from "./section/websiteBuilderSection";
import { TWebsiteBuilderNode } from "./websiteBuilderNode";

type TWebsiteBuilderHideableNode =
  | TWebsiteBuilderElement
  | TWebsiteBuilderContainer
  | TWebsiteBuilderSection;

export function isWebsiteBuilderHideableNode(node: TWebsiteBuilderNode): node is TWebsiteBuilderHideableNode {
  return node.type === "element" || node.type === "container" || node.type === "section";
}

export type TWebsiteBuilderHideableNodeVisibility = {
  [K in TWebsiteBuilderDevice]: boolean;
}

export function websiteBuilderGenerateDefaultHideableNodeVisibility(): TWebsiteBuilderHideableNodeVisibility {
  return {
    desktop: true,
    tablet: true,
    mobile: true,
  };
}

export function websiteBuilderNormalizeHideableNodeVisibility(partialVisibility: Partial<TWebsiteBuilderHideableNodeVisibility>): TWebsiteBuilderHideableNodeVisibility {
  const defaultVisibility = websiteBuilderGenerateDefaultHideableNodeVisibility();

  if (partialVisibility == null) {
    return defaultVisibility;
  }

  const normalizedVisibility: TWebsiteBuilderHideableNodeVisibility = {
    desktop: websiteBuilderNormalizeValue({
      type: "boolean",
      value: partialVisibility.desktop,
      defaultValue: defaultVisibility.desktop,
      required: true,
    }),
    tablet: websiteBuilderNormalizeValue({
      type: "boolean",
      value: partialVisibility.tablet,
      defaultValue: defaultVisibility.tablet,
      required: true,
    }),
    mobile: websiteBuilderNormalizeValue({
      type: "boolean",
      value: partialVisibility.mobile,
      defaultValue: defaultVisibility.mobile,
      required: true,
    }),
  };

  return normalizedVisibility;
}